import React, { FC } from 'react';
import { cx } from 'linaria';
import { RegularButton, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { ProductPriceView } from 'common/components/product-price-view';
import { card, cardRow, content, icon, iconRow, priceView, text } from './styles';
import { ViewsModels } from '../types';

type RelatedServiceProps = {
  service: ViewsModels.RelatedService;
};

export const RelatedService: FC<RelatedServiceProps> = ({ service: { iconLeftSrc, title, price } }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(card, cardRow)}>
      <div className={content}>
        {iconLeftSrc ? (
          <img
            className={cx(icon, iconRow)}
            src={iconLeftSrc}
            alt={title}
            data-qa="related-services-icon_mf-pdp"
          />
        ) : null}
        <Typography variant="s" size="body_long" color="text-primary" className={text}>
          {title}
        </Typography>
      </div>
      <RegularButton data-qa="related-services-button_mf-pdp" size="s" invert variant="primary">
        <Typography variant="s" size="subtitle" color="text-primary">
          {t('related-services.from')}
        </Typography>
        <ProductPriceView
          data-qa="related-services-price_mf-pdp"
          variant="subtitle"
          className={priceView}
          unit={null}
          intPart={`${price?.value}`}
          currency={t('ui.currency')}
        />
      </RegularButton>
    </div>
  );
};
